const ApiList =[
    {
        _id : 1,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 2,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 3,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    }
    ,{
        _id : 4,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 5,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 6,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 7,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 8,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 9,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    },
    {
        _id : 10,
        title : 'RTFKT Creators',
        author : 'by RTFKT',
        disc : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        bannerimg : '../assets/images/popularcolicon01.png',
        checkimg : '../assets/images/checkicon.svg',
        img2 : '../assets/images/popularcolimg03'
    }
]

export default ApiList